import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useOnboardingContext } from '../../Contexts/OnboardingContext';
import OnboardingAlert from '../OnboardingAlert';

const styles = () => ({
  root: {},
  errorAlert: {
    borderRadius: 0,
  },
});

const OnboardingErrorList = ({
  className,
  classes,
}) => {
  const {
    clientRefreshError,
    householdRefreshError,
  } = useOnboardingContext();

  const ONBOARDING_ERRORS = [
    {
      visible: clientRefreshError,
      message: 'There was an issue fetching your client information.',
    },
    {
      visible: householdRefreshError,
      message: 'There was an issue fetching your household information.',
    },
  ];

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {ONBOARDING_ERRORS.map((error) => {
        return (
          <OnboardingAlert
            key={error.message}
            className={classes.errorAlert}
            visible={error.visible}
            message={error.message}
            error
          />);
      })}
    </Box>
  );
};

OnboardingErrorList.defaultProps = {
  className: '',
};

OnboardingErrorList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingErrorList);
